// extracted by mini-css-extract-plugin
module.exports = {"illus":"BriefCreationModal_illus__2FDyO","beforeTitle":"BriefCreationModal_beforeTitle__WDcMq"};